import CircularProgress from "@mui/material/CircularProgress";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import React, { FC, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import Message from "./components/Message";
import {
  StyledMessagesContainer,
  StyledLoaderContainer,
  StyledLoader,
} from "./styled";

const Messages: FC<{ inputHeight: number }> = ({ inputHeight }) => {
  const {
    ticketMessages,
    handlePaginationChange,
    totalTicketMessagesCount,
    isLoadingTicketMessages,
  } = useCustomerTicketsPage();

  const containerRef = useRef<HTMLDivElement>(null);

  const { ref } = useInView({
    triggerOnce: true,
    onChange: (inView) => {
      if (
        (ticketMessages?.length || 0) < totalTicketMessagesCount &&
        inView &&
        !isLoadingTicketMessages
      ) {
        handlePaginationChange();
      }
    },
  });

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [ticketMessages]);

  if (!ticketMessages && isLoadingTicketMessages) {
    return (
      <StyledMessagesContainer ref={containerRef}>
        <StyledLoader>
          <CircularProgress />
        </StyledLoader>
      </StyledMessagesContainer>
    );
  }

  const reversedMessages = ticketMessages ? [...ticketMessages].reverse() : [];

  return (
    <StyledMessagesContainer
      ref={containerRef}
      style={{
        height: `calc(100vh - 72px - 60px - ${inputHeight}px - 48px)`,
      }} // 72px header, 60px InquiryHeader, 48px padding
    >
      {isLoadingTicketMessages && (
        <StyledLoaderContainer>
          <CircularProgress />
        </StyledLoaderContainer>
      )}
      {reversedMessages.map((message, index) => {
        const isPreLastItem = index === (ticketMessages?.length || 0) - 1;
        return (
          <div ref={isPreLastItem ? ref : null} key={message.id}>
            <Message key={message.id} message={message} />
          </div>
        );
      })}
    </StyledMessagesContainer>
  );
};

export default Messages;
